module.exports = __webpack_public_path__ + "3a78e14d3ffd812968fd5bb273b14622.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-girl-blonde.png
// module id = 2217
// module chunks = 0